import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string().required('emailRequired').email('emailInvalid'),
  roles: Yup.array().min(1, 'requiredRoles'),
  password: Yup.string()
    .required('passwordRequired')
    .min(12, 'newPasswordMinLength'),
  confirmPassword: Yup.string()
    .test(
      'passwordsDontMatch',
      'passwordsDontMatch',
      (_, { parent: { password, confirmPassword } }) =>
        password === confirmPassword,
    )
    .test(
      'confirmPasswordRequired',
      'confirmPasswordRequired',
      (_, { parent: { password, confirmPassword } }) =>
        !password || !!confirmPassword,
    ),
});
